import React, { useState } from "react";
import { Tabs, TabList, Tab, Box } from "@chakra-ui/react";
import RecurringTicketTable from "./RecurringTicketTable";
import { ticketRecurrences } from "../../../constants/ticketStatusConstants";

const RecurringTicketStatusTabs = ({ recurringTickets, confirmCompletionMark, confirmRecurrenceChange, confirmStatusChange, handleImagePreview, ticketStatuses }) => {
    const [selectedStatus, setSelectedStatus] = useState(ticketStatuses[0]?.code || "");
    const [selectedRecurrence, setSelectedRecurrence] = useState(0);

    return (
        <>
            <Tabs variant="solid-rounded" colorScheme="brand" onChange={(index) => setSelectedStatus(ticketStatuses[index]?.code)}>
                <Box overflowX="auto" whiteSpace="nowrap" css={{
                    "&::-webkit-scrollbar": { display: "none" },
                    "msOverflowStyle": "none",
                    "scrollbarWidth": "none",
                }}>
                    <TabList pl={4} display="flex" flexWrap="nowrap">
                        {ticketStatuses.map((tab) => (
                            <Tab key={tab.code} flexShrink={0} px={4} fontSize="sm" textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">{tab.name}</Tab>
                        ))}
                    </TabList>
                </Box>
            </Tabs>
            
            <Tabs variant="solid-rounded" colorScheme="accent" mt={4} onChange={(index) => setSelectedRecurrence(ticketRecurrences[index]?.code)}>
                <Box overflowX="auto" whiteSpace="nowrap" css={{
                    "&::-webkit-scrollbar": { display: "none" },
                    "msOverflowStyle": "none",
                    "scrollbarWidth": "none",
                }}>
                    <TabList pl={4} display="flex" flexWrap="nowrap">
                        {ticketRecurrences.map((recurrence) => (
                            <Tab key={recurrence.code} flexShrink={0} px={4} fontSize="sm" textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">{recurrence.name}</Tab>
                        ))}
                    </TabList>
                </Box>
            </Tabs>
            
            <Box mt={4} px={4}>
                <RecurringTicketTable 
                    recurringTickets = {recurringTickets}
                    recurrence={selectedRecurrence}
                    confirmRecurrenceChange={confirmRecurrenceChange}
                    status={selectedStatus} 
                    confirmCompletionMark={confirmCompletionMark}
                    handleImagePreview={handleImagePreview} 
                    confirmStatusChange={confirmStatusChange}
                />
            </Box>
        </>
    );
};

export default React.memo(RecurringTicketStatusTabs);